import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsExternalSelectRecipient = ({
  onNext = () => {},
  onBack = () => {},
  inputs,
  canGoNext,
}) => {
  const { t } = useTranslation(['rewards-gift', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view select-recipient">
        <div className="rewards-modal-input-row">
          {inputs.first && (
            <div className="input-container">
              <div className="input-label">{inputs.first.label}</div>
              {inputs.first.render()}
            </div>
          )}
        </div>
        {inputs.second && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className={`input-label ${inputs.second.disabled ? 'disabled' : ''}`}>
                {inputs.second.label}
              </div>
              {inputs.second.render()}
            </div>
          </div>
        )}
        {inputs.third && (
          <div className="rewards-modal-input-row">
            <div className="input-container inline">
              {inputs.third.render()}
              <div className="input-label checkbox-label">{inputs.third.label}</div>
            </div>
            {inputs.third && inputs.third.renderExtra && inputs.third.renderExtra()}
          </div>
        )}
        {inputs.fourth && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className="input-label">{inputs.fourth.label}</div>
              {inputs.fourth.render()}
            </div>
          </div>
        )}
      </div>

      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
          {t('rewards-gift:sendGiftForm.selectGiftButton')}
        </button>
      </div>
    </div>
  )
}

RewardsExternalSelectRecipient.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  inputs: PropTypes.object,
  canGoNext: PropTypes.bool,
}

export default RewardsExternalSelectRecipient
